import axios from "axios";

const lang = localStorage.getItem('lang') || 'en';
axios.defaults.headers.common["Accept-Language"] = lang;
axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;
